<template>
  <v-container fluid class="pa-0">
    <v-row class="pa-0">
      <v-col cols="12" v-if="model.exibirSalesforce">
        <a
          color="primary"
          target="_blank"
          style="text-align: center; display: block; margin: 2vh; text-decoration:none;"
          :href="`https://thinkcare.lightning.force.com/lightning/r/Quote/${model.cotacaoid}/view`"
        >
          <v-btn color="botao" block>
            <v-icon small left>fas fa-wallet</v-icon>Clique para acompanhar a cotação.
          </v-btn>
        </a>
      </v-col>
      <v-col cols="12" v-else>
        <v-stepper v-model="getcStep" vertical class="elevation-0 pa-1">
          <template v-for="(item, index) in steps">
            <v-stepper-step
              :key="index + '-step'"
              :complete="getcStep > index + 1"
              :step="index + 1"
              color="accent"
              complete-icon="fas fa-check"
              @click="backStep(index)"
              v-if="getcStep == index + 1 || item.respondido"
            >
              <span
                :class="getcStep == index + 1 ? 'black--text font-weight-bold subtitle-1' : 'body-2'"
              >{{ item.descricao }}</span>
              <span class="caption font-weight-bold" v-if="item.respondido">{{ item.respondido }}</span>
            </v-stepper-step>

            <v-stepper-content
              :step="index + 1"
              :key="index + '-stepcontent'"
              :class="getcStep == index + 1 ? '' : 'd-none'"
            >
              <v-row dense>
                <!-- regiões -->
                <template v-if="isAvailable(index, 0)">
                  <v-col cols="12">
                    <div style="max-width: 97vw">
                      <p class="text-justify" v-html="getStepInfo('city')"></p>
                    </div>
                    <auto-complete-cidade
                      :loadquote="model"
                      @evento="(_data) => {selecionarCidade(_data, item)}"
                    />
                  </v-col>
                </template>

                <!-- Tipo de projeto -->
                <template v-if="isAvailable(index, 1)">
                  <study-configuration-select
                    :model="model"
                    @selecionar="() => { SelecionarProjeto(item) }"
                    @semdados="() => { backStep(0) }"
                  />
                </template>

                <!-- Dependentes -->
                <template v-if="index == 2">
                  <v-col cols="12" class="p-5">
                    <div class="p-5" style="max-width: 97vw">
                      <p class="text-justify" v-html="getStepInfo('dependent-pf')"></p>
                    </div>
                    <small
                      class="pre-text"
                      v-if="model.selectProjeto && model.selectProjeto.minimum_lives"
                    >{{`Selecione de ${model.selectProjeto.minimum_lives} a ${model.selectProjeto.maximum_lives - 1} dependentes`}}</small>
                  </v-col>
                  <v-col cols="12" class="mt-5 pt-5">
                    <div v-if="model.selectProjeto && model.selectProjeto.maximum_lives">
                      <v-slider
                        color="primary"
                        v-model="qtdDependentesView"
                        step="1"
                        thumb-label="always"
                        min="0"
                        :max="model.selectProjeto.maximum_lives - 1"
                      >
                        <template v-slot:prepend>
                          <v-icon color @click="qtdDependentesView--">fas fa-minus</v-icon>
                        </template>

                        <template v-slot:append>
                          <v-icon @click="qtdDependentesView++">fas fa-plus</v-icon>
                        </template>
                      </v-slider>
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <v-btn color="botao" @click="getDependentes(item)" block>
                      <v-icon small left>fas fa-check</v-icon>Continuar
                    </v-btn>
                  </v-col>
                </template>

                <!-- categoria Dependentes -->
                <template v-if="index == 3">
                  <v-col cols="12">
                    <p class="text-justify" v-html="getStepInfo('age-pf')"></p>
                    <div>
                      <table v-if="model.beneficiarios && model.beneficiarios.length>0">
                        <tr>
                          <td>
                            <v-select
                              style="max-width: 90%"
                              label="Tipo"
                              placeholder=" "
                              v-model="model.beneficiarios[0].tipo"
                              :items="['Titular']"
                              outlined
                            ></v-select>
                          </td>
                          <td>
                            <v-text-field
                              v-model="model.beneficiarios[0].idade"
                              label="Idade"
                              placeholder=" "
                              type="number"
                              min="0"
                              outlined
                            />
                          </td>
                        </tr>

                        <!-- demais dependentes -->
                        <tr
                          :key="'list-item-cat-depend' + ind"
                          v-for="(dep, ind) in model.beneficiarios"
                        >
                          <td v-if="ind>0">
                            <v-select
                              v-if="tipoDependentes.length==1"
                              style="max-width: 90%"
                              :items="tipoDependentes"
                              label="Dependente"
                              placeholder=" "
                              v-model="dep.tipo"
                              outlined
                            ></v-select>
                            <v-select
                              v-else
                              style="max-width: 90%"
                              :items="['Dependente']"
                              label="Dependente"
                              placeholder=" "
                              v-model="dep.tipo"
                              outlined
                            ></v-select>
                          </td>
                          <td v-if="ind>0">
                            <v-text-field
                              label="Idade"
                              placeholder=" "
                              v-model="dep.idade"
                              type="number"
                              outlined
                            />
                          </td>
                        </tr>
                      </table>
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <v-btn color="botao" block @click="selecionarCategoriaDependente(item)">
                      <v-icon small left>fas fa-check</v-icon>Continuar
                    </v-btn>
                  </v-col>
                </template>

                <!-- Conforto -->
                <template v-if="isAvailable(index, 4)">
                  <accomodations-select
                    :model="model"
                    @selecionar="() => { selecionarConforto(item) }"
                    @semdados="() => { backStep(2) }"
                  />
                </template>

                <!--Cooparticipação  -->
                <template v-if="isAvailable(index, 5)">
                  <copays-select
                    :model="model"
                    @selecionar="() => { selecionarCoparticipacao(item) }"
                    @semdados="() => { backStep(3) }"
                  />
                </template>

                <!-- Total -->
                <template v-if="isAvailable(index, 6)">
                  <v-col cols="12" v-if="operadoras && operadoras.length > 0">
                    <div class="p-5" style="max-width: 97vw">
                      <p class="text-justify" v-html="getStepInfo('price', getPrecoInicial())"></p>
                    </div>
                    <br />
                    <v-expansion-panels>
                      <v-expansion-panel v-for="(seg, s) in operadoras" :key="'se'+s">
                        <seguradora-item
                          :img="seg.img"
                          :nome="seg.nome"
                          :preco="$util.formatBRL(seg.planos[0].preco)"
                        />
                        <v-expansion-panel-content>
                          <table style="width: 100%">
                            <plano-item
                              v-for="(pls, p) in seg.planos"
                              :key="'plas'+p"
                              :nome="pls.nome"
                              :segmentacao="pls.segmentacao"
                              :acomodacao="pls.acomodacao"
                              :coparticipacao="pls.coparticipacao ? pls.coparticipacao : null"
                              :preco="pls.preco ? $util.formatBRL(pls.preco) : null"
                              :coparticipacao2="pls.coparticipacao2 ? pls.coparticipacao2 : null"
                              :preco2="pls.preco2 ? $util.formatBRL(pls.preco2): null"
                              :check="pls.check"
                              :regiao="pls.regiao.name"
                              @evento="selectPlano(pls)"
                            />
                          </table>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                  <v-col cols="12" v-if="model.planos && model.planos.length > 0">
                    <v-btn color="botao" block @click="cotacaoSelecionar(item)">
                      <v-icon small left>fas fa-check</v-icon>Continuar
                    </v-btn>
                  </v-col>
                </template>

                <!-- dados pessoais -->
                <template v-if="index == 7">
                  <v-col cols="12">
                    <v-text-field
                      v-model="model.user.name"
                      label="Nome *"
                      placeholder=" "
                      type="text"
                      outlined
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="model.user.cpfCnpj"
                      @input="model.user.cpfCnpj = $event.toUpperCase()"
                      label="CPF *"
                      placeholder=" "
                      type="text"
                      outlined
                      v-mask="$util.formmasks.cpfcnpj"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="model.user.email"
                      placeholder=" "
                      label="Email *"
                      type="email"
                      outlined
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      v-model="model.user.phonePrefix"
                      label="DDD *"
                      placeholder=" "
                      outlined
                    />
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      v-model="model.user.phone"
                      label="Telefone *"
                      placeholder=" "
                      type="text"
                      outlined
                      v-mask="$util.formmasks.telefone"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-btn class="no-text-transform" color="botao" block @click="emitirCotacao()">
                      <small>Emitir Cotação</small>
                    </v-btn>
                  </v-col>
                </template>
              </v-row>
            </v-stepper-content>
          </template>
        </v-stepper>
      </v-col>

      <template v-if="getcStep > steps.length">
        <template v-if="cSelectFinalPlano">
          <v-col cols="12">
            <v-btn color="botao" block @click="finalizarCarrinho()">
              <v-icon small left>fas fa-wallet</v-icon>Finalizar
            </v-btn>
          </v-col>
        </template>
      </template>
    </v-row>
  </v-container>
</template>

<script>
/* eslint-disable */
import store from "../../store/store";
import { mapMutations, mapState } from "vuex";

// shared
import RegiaoItemList from "../shared/model/regiao.vue";
import SeguradoraItem from "../shared/model/seguradora.vue";
import SeguradoraPlanosItem from "../shared/model/seguradoraPlanos.vue";

import StudyConfigurationService from "../../services/salesforce/StudyConfigurationService";
import ProductService from "../../services/salesforce/ProductService";
import InsurancePricingService from "../../services/salesforce/InsurancePricingService";
import SecurityService from "../../services/salesforce/SecurityService";
import MessageInfoService from "../../services/salesforce/MessageInfoService";

//componentes
import AutoCompleteCidade from "../../components/autocomplete-cidade";
import StudyConfiguration from "../../components/study-configuration-select";
import AccomodationsSelect from "../../components/accomodations-select";
import CopaysSelect from "../../components/copays-select";

export default {
  components: {
    "study-configuration-select": StudyConfiguration,
    "accomodations-select": AccomodationsSelect,
    "copays-select": CopaysSelect,
    "regiao-item-list": RegiaoItemList,
    "seguradora-item": SeguradoraItem,
    "plano-item": SeguradoraPlanosItem,
    "auto-complete-cidade": AutoCompleteCidade,
  },
  data() {
    return {
      model: {
        persontype: "PF",
        selectProjeto: null,
        origin: "Cotador",
        accommodation: [],
        cooparticipacao: [],
        beneficiarios: [],
        planos: [],
        user: {
          cpfCnpj: "",
          email: "",
          name: "",
          phone: "",
          phonePrefix: "",
          mobilePhone: "",
          mobilePhonePrefix: "",
          companyName: "",
        },
        region: {
          label: "",
          value: "",
        },
        cotacaoid: "",
        exibirSalesforce: false,
      },
      cplano: [],
      cregiao: null,
      cpessoafisica: true,
      cenviarporemail: false,
      selectfinalplan: false,
      cSelectFinalPlano: null,
      ctabelaD: 0,
      ctabelaT: 0,
      qtdDependentesView: 0,
      qtdDependentes: 1,
      tipoDependentes: ["Dependente", "Agregado"],
      operadoras: [],
      regioes: [],
      acomodacoes: [],
      cooparticipacao: [],
      titularDependente: "Titular",
      steps: [
        {
          descricao: "",
          respondido: false,
        },
        {
          descricao: "Projetos",
          respondido: false,
        },
        {
          descricao: "Quantos dependentes?",
          respondido: false,
        },
        {
          descricao: "Idade",
          respondido: false,
        },
        {
          descricao: "Conforto",
          respondido: false,
        },
        {
          descricao: "Só preciso de mais uma informação.",
          respondido: false,
        },
        {
          descricao: "Cotação",
          respondido: false,
        },
        {
          descricao: "Informe seus dados para receber a cotação",
          respondido: false,
        },
      ],
      item: {},
      cStep: 1,
      salesforce: false,
      projetos: [],
    };
  },
  created() {
    this.model.origin = this.$route.query.origin || "Cotador";
    this.model.type = this.$route.query.type || "HEALTH";
    this.model.exibirSalesforce = false;

    this.model.exibirSalesforce = this.salesforce;
    this._insurancePricingService = new InsurancePricingService();
    this._studyconfiguration = new StudyConfigurationService();
    this._productService = new ProductService();
    this._securityService = new SecurityService();
    this.messageInfo = new MessageInfoService();

    switch (this.$route.query.origin) {
      case "salesforce":
        this.salesforce = true;
        break;
    }
  },
  mounted() {
    // salesforce
    this.loadQuote();
  },
  props: {
    id: null,
    origin: {
      type: String,
    },
    personType: {
      type: String,
    },
  },
  methods: {
    ...mapMutations(["toogleDialogLoading"]),

    getStepInfo(step, params) {
      return this.messageInfo.getExplanation(step, params);
    },
    naoDisponivel() {
      store.commit("showmsg", {
        text: this.getStepInfo("nao-disponivel"),
        type: "warning",
      });
    },

    genericError() {
      store.commit("showmsg", {
        text:
          "Me desculpe, mas no momento, estamos com problemas em nosso servidores, aguarde alguns minutos e tente novamente. Obrigado",
        type: "warning",
      });
    },

    async getCurrentUser() {
      let user = await this._securityService.getCurrentUser("PF");
      if (user) {
        this.model.user = user;
      }
    },
    async loadQuote() {
      if (localStorage.getItem("current_quote")) {
        this.model = await JSON.parse(localStorage.getItem("current_quote"));
        this.toogleDialogLoading(true);
      } else {
        this.getCurrentUser();
      }
    },

    isAvailable(index, current) {
      return this.getcStep == index + 1 && index == current;
    },
    selecionarCidade(data, item) {
      this.model.region = data;
      item.descricao = "Cidade";
      this.addCstep(item, 1, data.Name);
    },
    selecionarCategoriaDependente(item) {
      if (
        this.model.beneficiarios &&
        this.model.beneficiarios.filter((c) => c.idade == null).length > 0
      ) {
        store.commit("showmsg", {
          text: "Informe as idades de todos os dependentes e do titular.",
          type: "warning",
        });
        return;
      }
      // ok
      this.addCstep(item, 1, "Ok");
    },
    selecionarConforto(item) {
      let acc = this.model.accommodation.filter((f) => f.check);
      let nomes = acc.map((m) => m.label);

      this.addCstep(item, 1, nomes.join(" ou "));
    },
    selecionarCoparticipacao(item) {
      let acc = this.model.cooparticipacao.filter((f) => f.check);
      let nomes = acc.map((m) => m.label);
      this.addCstep(item, 1, nomes.join(" ou "));

      this.operadoras = [];
      this.model.planos = [];

      setTimeout(() => {
        this.toogleDialogLoading(true);
      }, 100);

      this.getSimulate().then((res) => {
        if (!this.operadoras || this.operadoras.length <= 0) {
          this.naoDisponivel();
        }
      });
    },

    cotacaoSelecionar(item) {
      var permiteAvancar = true;
      this.model.planos.forEach((pl) => {
        if (
          this.model.planos.filter(
            (fil) => fil.seguradora == pl.seguradora && fil.check
          ).length > 5
        ) {
          store.commit("showmsg", {
            text: "Permitido apenas 5 planos por operadora.",
            type: "warning",
          });

          permiteAvancar = false;
        }
      });
      if (permiteAvancar) {
        this.addCstep(item, 1, "OK");
      }
    },
    planosList() {
      if (this.cenviarporemail) {
        return this.cplano;
      }
      return this.planos;
    },

    planosSelectList() {
      return this.planos;
    },

    funDownload() {
      this.cplano.forEach((el) => {
        window.open(el.urlpdf, "_blank");
      });
    },

    habilitarEnviarPorEmail() {
      this.cenviarporemail = !this.cenviarporemail;
    },

    enviarCotacaoPorEmail() {
      store.commit("showmsg", {
        text: "Cotação enviada por e-mail com sucesso.",
        type: "success",
      });
    },
    getPrecoInicial() {
      return this.$util.formatBRL(
        this.operadoras[0].planos.filter((c) => c.preco > 0)[0].preco
      );
    },
    backStep(n) {
      for (let con = 0; con < this.steps.length; con++) {
        if (n < con) this.steps[con].respondido = null;
      }

      if (this.steps[n].descricao == "Cidade") {
        this.steps[n].descricao = "";
      }
      this.steps[n].respondido = null;
      this.getcStep = n + 1;

      this.model.loadquote = false;
    },

    addCstep(item, n, resposta) {
      item.respondido = resposta ? resposta : true;
      this.getcStep = this.getcStep + n;
    },

    addCarrinho(item) {
      this.$util.link("produtos");
    },

    finalizarCarrinho(item) {
      this.addCarrinho(item);
      alert("cotação enviada com sucesso");
    },

    selectPlano(plano) {
      plano.check = !plano.check;
      if (plano.check) {
        this.model.planos.push(plano);
      } else {
        this.model.planos = this.model.planos.filter(
          (f) => f.nome != plano.nome
        );
      }
    },

    selecFinalPlano(plano, cod) {
      this.cSelectFinalPlano = plano;
      this.addCstep(
        this.steps[cod],
        1,
        `${plano.seguradora}-${plano.nome}-${plano.preco}`
      );
    },

    selectRegiao(regiao, cod) {
      this.model.region = regiao;
      this.cregiao = regiao;
      this.addCstep(this.steps[cod], 1, regiao.label);
    },

    SelecionarProjeto(item) {
      this.tipoDependentes = ["Dependente"];
      if (this.model.selectProjeto.show_aggregate__c) {
        this.tipoDependentes.push("Agregado");
      }
      this.addCstep(item, 1, this.model.selectProjeto.name);

      if (this.model.loadquote) {
        this.qtdDependentesView = this.model.beneficiarios.length - 1;
        var _item = this.steps[2];
        this.getDependentes(_item);
      }
    },

    getTotal(vlD, vlT) {
      let total = 0;

      if (vlD) total = parseInt(vlD);
      if (vlT) total += parseInt(vlT);
      return total;
    },

    getDependentes(item) {
      this.qtdDependentes = this.qtdDependentesView + 1;
      if (this.qtdDependentes == 0) this.qtdDependentes++;

      if (!this.model.loadquote) {
        this.model.beneficiarios = this.model.beneficiarios.slice(
          0,
          this.qtdDependentes
        );
      }

      if (this.qtdDependentes != this.model.beneficiarios.length) {
        for (let index = 0; index < this.qtdDependentes; index++) {
          if (this.model.beneficiarios.length < this.qtdDependentes) {
            this.model.beneficiarios.push({
              idade: null,
              tipo:
                this.model.beneficiarios.length > 0
                  ? this.tipoDependentes.length == 1
                    ? "Dependente"
                    : ""
                  : "",
            });
          }
        }
      }

      this.model.beneficiarios[0].tipo = "Titular";
      this.addCstep(item, 1, this.qtdDependentes - 1 + " dependente(s)");

      if (this.model.loadquote) {
        var _item = this.steps[3];
        this.selecionarCategoriaDependente(_item);
      }
    },

    setDependente(vlD, vlT) {
      this.qtdDependentes += this.getTotal(vlD, vlT);
    },
    async getSimulate() {
      this.model.simulate = true;
      await this._insurancePricingService
        .Simulate(this.model)
        .then((res) => {
          this.preencheCotacoes(res);
        })
        .catch((reason) => {
          console.log(JSON.stringify(reason));
          this.genericError();
        })
        .finally(() => this.toogleDialogLoading(false));
    },
    async preencheCotacoes(res) {
      this.operadoras = await this._insurancePricingService.getQuotePrice(
        res.data
      );

      if (this.model.loadquote) {
        if (this.model.planosload && this.model.planosload.length > 0) {
          this.model.planosload.forEach((plan) => {
            for (let index = 0; index < this.operadoras.length; index++) {
              this.operadoras[index].planos.forEach((planOperadora) => {
                if (plan.productId === planOperadora.productId) {
                  this.selectPlano(planOperadora);
                  planOperadora.check = true;
                }
              });
            }
          });
        }
      }

      if (this.model.loadquote) {
        store.commit("showmsg", {
          text: this.getStepInfo("remissao-quote"),
          type: "success",
        });
      }
    },

    isValidCotacao() {
      var bValid = true;
      var msg = "";

      if (!this.model.user.name) {
        bValid = false;
        msg = "Informe o nome";
      }

      if (!this.model.user.cpfCnpj) {
        bValid = false;
        msg = "Informe o CPF";
      }

      if (this.model.user.cpfCnpj.length < 11) {
        bValid = false;
        msg = "Informe o CPF válido";
      }

      if (!this.model.user.phonePrefix) {
        bValid = false;
        msg = "Informe o DDD do telefone";
      }

      if (!this.model.user.phone) {
        bValid = false;
        msg = "Informe um telefone";
      }

      if (this.model.user.phone.length < 8) {
        bValid = false;
        msg = "Informe um telefone válido ";
      }

      if (!this.model.user.email) {
        bValid = false;
        msg = "Informe u email";
      }

      if (!this.model.user.email.includes("@")) {
        bValid = false;
        msg = "Informe um e-mail válido";
      }

      if (!bValid) {
        store.commit("showmsg", {
          text: msg,
          type: "warning",
        });
      }

      return bValid;
    },

    emitirCotacao() {
      if (this.isValidCotacao()) {
        this.toogleDialogLoading(true);
        this.model.simulate = false;
        this._insurancePricingService
          .Quote(this.model)
          .then((res) => {
            this.model.cotacaoid = res.data.id;

            this.model.exibirSalesforce =
              this.$route.query.origin == "salesforce";
            this.salesforce = this.$route.query.origin == "salesforce";

            localStorage.removeItem("current_addfields");
            localStorage.removeItem("current_quote");
            localStorage.removeItem("user_current");

            if (!this.model.exibirSalesforce) {
              this.model.loadquote = false;

              store.commit("showmsg", {
                text:
                  "Sua cotação foi emitida e enviada para o e-mail informado no formulário de Cotação.",
                type: "success",
                redirect: `produto?origin=${this.model.origin}`,
              });
            } else {
              store.commit("showmsg", {
                text: "Cotação emitida com sucesso",
                type: "success",
              });
            }
          })
          .catch((reason) => {
            console.log(JSON.stringify(reason));
            store.commit("showmsg", {
              text: "não conseguimos emitir sua cotação no momento",
              type: "error",
            });
          })
          .finally(() => {
            this.toogleDialogLoading(false);
          });
      }
    },
  },
  computed: {
    getcStep: {
      get: function () {
        return this.cStep;
      },
      set: function (value) {
        this.cStep = value;
      },
    },
  },
};
</script>

<style>
.botao {
  background-color: var(--v-btnprimary-base) !important;
  border-color: var(--v-btnprimary-base) !important;
  color: var(--v-foreground-base) !important;
}
button {
  margin-bottom: 5px;
}
.cotacao {
  display: flex;
  align-items: center;
}

.cotacao img {
  width: 60px;
  height: 40px;
  border-radius: 50%;
}

.cotacao h3 {
  font-size: 20px;
  margin-left: 10px;
  margin-top: 0px !important;
}
.cotacao h3 span {
  font-size: 12px;
  color: var(--v-foreground-base);
}

.ul-planos {
  list-style: none;
  padding-left: 5px !important;
}

.ul-planos li {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  align-items: center;
}
.ul-planos li strong {
  text-transform: uppercase;
  color: var(--v-foreground-base);
}

.checkmark {
  height: 18px;
  width: 18px;
  border-radius: 50%;
}
/* stepper style */
.v-stepper__content {
  border: 0 !important;
  margin-left: 0 !important;
}
.v-stepper__step--active > span,
.v-stepper__step--inactive > span {
  display: none;
}
.v-stepper {
  background-color: transparent !important;
}
.v-stepper__step,
.v-stepper__content {
  padding-left: 5px !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.v-stepper--vertical .v-stepper__content {
  margin-top: -16px !important;
  padding-right: 40px !important;
}

.pre-text {
  color: darkgray;
  font-size: 10px;
}

.tituloProduto {
  background-color: var(--v-primary);
  position: absolute;
  width: 100%;
  bottom: 0;
}

.v-expansion-panel-content__wrap {
  padding: 0px 0px 0px 10px !important;
}

.v-expansion-panels {
  z-index: auto !important;
}

.v-stepper__wrapper {
  height: auto !important;
}
</style>
